import type { Route } from '../core/types';
import { paceDuration } from './paceModel';
import { planFerry } from './ferry';

/** Use the same travel time as the preview, including scheduled ferry waits. */
export function fastestRouteOrder(routes: Route[], truck: boolean, now = Date.now()): Route[] {
  return routes.map((route, index) => {
    const duration = paceDuration(route);
    const seconds = duration + (planFerry(route, duration, now, truck)?.waitSeconds ?? 0);
    return { route, index, seconds: Number.isFinite(seconds) && seconds >= 0 ? seconds : Infinity };
  }).sort((a, b) => a.seconds - b.seconds || a.index - b.index).map(entry => entry.route);
}
